import styled from 'styled-components';
import CheckIcon from '@mui/icons-material/Check';
import ErrorIcon from '@mui/icons-material/Error';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';

import { ReactComponent as AnnotationIcon } from '@/assets/icons/indications/annoItem.svg';
import { ReactComponent as AreaIcon } from '@/assets/icons/indications/areaItem.svg';
import { ReactComponent as SplineIcon } from '@/assets/icons/indications/splineItem.svg';
import { ReactComponent as AngleIcon } from '@/assets/icons/indications/angleItem.svg';
import { ReactComponent as DistanceIcon } from '@/assets/icons/indications/distanceItem.svg';
import { ReactComponent as PointIcon } from '@/assets/icons/indications/pointItem.svg';

export const Container = styled.div`
  position: relative;
`;

export const ButtonsContainer = styled.div`
  position: absolute;
  top: -2.6em;
  right: 0;
`;

export const Divider = styled.div`
  height: 1.5rem;
`;

const CriteriaIconStyles = {
  'vertical-align': 'middle'
};

const IndicationIconStyles = {
  'vertical-align': 'middle',
  width: '1.5em'
};

export const SuccessCriteriaIcon = styled(CheckIcon)(CriteriaIconStyles);
export const ErrorCriteriaIcon = styled(ErrorIcon)(CriteriaIconStyles);
export const WarningCriteriaIcon = styled(ErrorOutlineIcon)(CriteriaIconStyles);
export const AnnotationIndicationIcon = styled(AnnotationIcon)(IndicationIconStyles);
export const AreaIndicationIcon = styled(AreaIcon)(IndicationIconStyles);
export const SplineIndicationIcon = styled(SplineIcon)(IndicationIconStyles);
export const DistanceIndicationIcon = styled(DistanceIcon)(IndicationIconStyles);
export const AngleIndicationIcon = styled(AngleIcon)(IndicationIconStyles);
export const WorkflowIndicationIcon = styled(PointIcon)(IndicationIconStyles);
export const CheckBoxBlankIcon = styled(CheckBoxOutlineBlankOutlinedIcon)(CriteriaIconStyles);
export const CheckBoxIcon = styled(CheckBoxOutlinedIcon)(CriteriaIconStyles);
